import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { translate } from "react-i18next";
import _ from "lodash";
import { Field, reduxForm, formValueSelector, reset } from "redux-form";
import { Col, Button, Form, FormGroup, Alert } from "reactstrap";
import { statusEnum, USER_GROUP, USER_LANG } from "../actions/constant";
import {
  InputAmount,
  InputText,
  Dropdown,
  CheckBox,
  Loading,
  Validations,
  VautoComplete,
  Valert,
} from "../components";
import ReCAPTCHA from "react-google-recaptcha";
import classNames from "classnames";
import moment from "moment";
import CryptoJS from "crypto-js";
import signUpActions from "../actions/signUpActions";
import {
  monthOptions as arrMonthOptions,
  genderOptions,
  getYearOptions,
  getMonthOptionsTrans,
} from "../components/componentsConstant";

import {
  isLoadedFromMobile,
  getCurrentOrientation,
} from "../services/MobileService";
import { Orientations } from "./PageConstants";
import config from "../config";

import { getEthnicitiesOptions } from "../services/LookupService";
import queryString from "../services/QueryStringService";
import i18n from "../i18n";
import "./styles/signupPage.css";
import "./styles/authModern.css";

// password validation
const min8 = Validations.min8;
const max15 = Validations.max15;
const minOneUppercase = Validations.min_one_uppercase;
const minOneLowercase = Validations.min_one_lowercase;
const minOneNumber = Validations.min_one_number;
const minOneSpecial = Validations.min_one_special;
const passChecker = (value) => {
  var resutl = undefined;
  var final = "";
  resutl = min8(value);
  if (resutl) return resutl;
  resutl = minOneUppercase(value);
  if (resutl) return resutl;
  resutl = minOneLowercase(value);
  if (resutl) return resutl;
  resutl = minOneNumber(value);
  if (resutl) return resutl;
  resutl = minOneSpecial(value);
  if (resutl) return resutl;
  resutl = max15(value);
  if (resutl) return resutl;
  return "";
};

// new custom pass checker
let min8Checker;
let max15Checker;
let minOneUppercaseChecker;
let minOneLowercaseChecker;
let minOneNumberChecker;
let minOneSpecialChecker;

let customPassChecker = (value) => {
  min8Checker = value && Validations.min8(value) ? false : true;
  max15Checker = Validations.max15(value) ? false : true;
  minOneUppercaseChecker = Validations.min_one_uppercase(value) ? false : true;
  minOneLowercaseChecker = Validations.min_one_lowercase(value) ? false : true;
  minOneNumberChecker = Validations.min_one_number(value) ? false : true;
  minOneSpecialChecker = Validations.min_one_special(value) ? false : true;
};

// TODO:
// might be better be able to put this styling to a CSS
var _linkStyle = {
  color: "#007bff",
};
var _paragraphStyle = {
  textIndent: "30px",
};

/**
 * A Custom Modal View that appears when user clicks on the Agreeement Link
 */
let AgreementModal = (props) => {
  const t = props.t;

  //let _msg = t('agreement.MSG_1') + t('agreement.MSG_2') + t('agreement.MSG_3') + t('agreement.MSG_4');

  return (
    <div className="agreement-popup">
      <article>
        <div
          style={{
            textDecoration: "underline",
            textAlign: "center",
            marginBottom: "15px",
            fontSize: "1.25rem",
            fontWeight: "700",
          }}
        >
          {t("agreement.TITLE")}
        </div>
        <div>
          <p
            className="forgot-title"
            style={{
              marginBottom: "20px",
              fontSize: "1rem",
              fontWeight: "bold",
            }}
          >
            {t("agreement.LEAD")}
          </p>
        </div>
        <p className="paraMessages">{t("agreement.MSG_1")}</p>
        <p className="paraMessages">{t("agreement.MSG_2")}</p>
        <div className="paraHeadears">{t("agreement.MSG_3_TITLE")}</div>
        <p className="paraMessages">{t("agreement.MSG_3")}</p>
        <p className="paraMessages">{t("agreement.MSG_4")}</p>
        <p className="paraMessages">{t("agreement.MSG_5")}</p>
        <div className="paraHeadears">{t("agreement.MSG_6_TITLE")}</div>
        <p className="paraMessages">{t("agreement.MSG_7")}</p>
        <div className="paraHeadears">{t("agreement.MSG_8_TITLE")}</div>
        <p className="paraMessages">{t("agreement.MSG_9")}</p>
        <div className="paraHeadears">{t("agreement.MSG_10_TITLE")}</div>
        <p className="paraMessages">{t("agreement.MSG_11")}</p>
        <div className="paraHeadears">{t("agreement.MSG_12_TITLE")}</div>
        <p className="paraMessages">{t("agreement.MSG_13")}</p>
        <p className="paraMessages">{t("agreement.MSG_14")}</p>
        <p className="paraMessages">{t("agreement.MSG_15")}</p>
        <p className="paraMessages">{t("agreement.MSG_16")}</p>
        <div>
          <span style={{ position: "absolute", marginLeft: "20px" }}>1. </span>
          <p className="paraMessages" style={{ marginLeft: "40px" }}>
            {t("agreement.MSG_17")}
          </p>
          <span style={{ position: "absolute", marginLeft: "20px" }}>2. </span>
          <p className="paraMessages" style={{ marginLeft: "40px" }}>
            {t("agreement.MSG_18")}
          </p>
        </div>
        {/* <ol>
          <ul className="paraMessages">
            <span style={{ position: "absolute" }}>
              {t("agreement.MSG_17")}
            </span>
          </ul>
          <ul className="paraMessages">{t("agreement.MSG_18")}</ul>
        </ol> */}
        <p className="paraMessages">{t("agreement.MSG_19")}</p>
        <div className="paraHeadears">{t("agreement.MSG_20_TITLE")}</div>
        <p className="paraMessages">{t("agreement.MSG_21")}</p>
        <div className="paraHeadears">{t("agreement.MSG_22_TITLE")}</div>
        <p className="paraMessages">{t("agreement.MSG_23")}</p>
        <p className="paraMessages">{t("agreement.MSG_24")}</p>
        <div className="paraHeadears">{t("agreement.MSG_25_TITLE")}</div>
        <p className="paraMessages">{t("agreement.MSG_26")}</p>
        <div className="paraHeadears">{t("agreement.MSG_27_TITLE")}</div>
        <p className="paraMessages">{t("agreement.MSG_28")}</p>
        <div className="paraHeadears">{t("agreement.MSG_29_TITLE")}</div>
        <p className="paraMessages">{t("agreement.MSG_30")}</p>
        <p className="paraMessages">{t("agreement.MSG_31")}</p>
        <p className="paraMessages">{t("agreement.MSG_32")}</p>
        <div className="paraHeadears">{t("agreement.MSG_33_TITLE")}</div>
        <p className="paraMessages">{t("agreement.MSG_34")}</p>
        <p className="paraMessages" style={{ fontWeight: "bold" }}>
          {t("agreement.MSG_35")}
        </p>

        <br />
      </article>
      <div
        align="center"
        onClick={() => {
          localStorage.setItem("i18nextLng", i18n.language);
        }}
      >
        <a className="linkStyle" onClick={props.clicked}>
          {t("agreement.UNDERSTAND")}
        </a>
      </div>
    </div>
  );
};
let PrivacyModal = (props) => {
  const t = props.t;

  //let _msg = t('agreement.MSG_1') + t('agreement.MSG_2') + t('agreement.MSG_3') + t('agreement.MSG_4');

  return (
    <div className="agreement-popup">
      <article>
        <div
          style={{
            textDecoration: "underline",
            textAlign: "center",
            fontSize: "1.25rem",
            fontWeight: "700",
            marginBottom: "1rem",
          }}
        >
          {t("privacy.TITLE")}
        </div>
        <p className="paraMessages">{t("privacy.MSG_1")}</p>
        <p className="paraMessages">{t("privacy.MSG_2")}</p>
        <p className="paraMessages">{t("privacy.MSG_3")}</p>
        <p className="paraMessages">{t("privacy.MSG_4")}</p>
        <div className="paraHeadears">{t("privacy.MSG_5_TITLE")}</div>
        <p className="paraMessages">{t("privacy.MSG_6")}</p>
        <div className="paraHeadears" style={{ textDecoration: "none" }}>
          {t("privacy.MSG_7_TITLE")}
        </div>
        <p className="paraMessages">{t("privacy.MSG_8")}</p>
        <div className="paraHeadears" style={{ textDecoration: "none" }}>
          {t("privacy.MSG_9_TITLE")}
        </div>
        <p className="paraMessages">{t("privacy.MSG_10")}</p>
        <p className="paraMessages">{t("privacy.MSG_11")}</p>
        <p className="paraMessages">{t("privacy.MSG_12")}</p>
        <div className="paraHeadears" style={{ textDecoration: "none" }}>
          {t("privacy.MSG_13_TITLE")}
        </div>
        <p className="paraMessages">{t("privacy.MSG_14")}</p>
        <div className="paraHeadears" style={{ textDecoration: "none" }}>
          {t("privacy.MSG_15_TITLE")}
        </div>
        <p className="paraMessages">{t("privacy.MSG_16")}</p>
        <div className="paraHeadears" style={{ textDecoration: "none" }}>
          {t("privacy.MSG_17_TITLE")}
        </div>
        <p className="paraMessages">{t("privacy.MSG_18")}</p>
        <div className="paraHeadears" style={{ textDecoration: "none" }}>
          {t("privacy.MSG_19_TITLE")}
        </div>
        <p className="paraMessages">{t("privacy.MSG_20")}</p>
        <div className="paraHeadears">{t("privacy.MSG_21_TITLE")}</div>
        <p className="paraMessages">
          <span style={{ fontWeight: "bold" }}>{t("privacy.MSG_106")}</span>
          {t("privacy.MSG_22")}
        </p>
        <ul
          style={{
            listStyleType: "disc",
            marginLeft: "20px",
            marginBottom: "20px",
            textAlign: "justify",
          }}
        >
          <li className="paraMessages" style={{ marginBottom: "10px" }}>
            <span style={{ fontWeight: "bold" }}>{t("privacy.MSG_23")}</span>{" "}
            {t("privacy.MSG_24")}
          </li>
          <li className="paraMessages" style={{ marginBottom: "10px" }}>
            <span style={{ fontWeight: "bold" }}>{t("privacy.MSG_25")}</span>{" "}
            {t("privacy.MSG_26")}
          </li>
          <li className="paraMessages">
            <span style={{ fontWeight: "bold" }}>{t("privacy.MSG_27")}</span>{" "}
            {t("privacy.MSG_28")}
          </li>
        </ul>
        <p className="paraMessages">
          <span style={{ fontWeight: "bold" }}>{t("privacy.MSG_29")}</span>{" "}
          {t("privacy.MSG_30")}
        </p>
        <p className="paraMessages">
          <span style={{ fontWeight: "bold" }}>{t("privacy.MSG_31")}</span>{" "}
          {t("privacy.MSG_32")}
        </p>
        <div className="paraHeadears" style={{ textDecoration: "none" }}>
          {t("privacy.MSG_33_TITLE")}
        </div>
        <p className="paraMessages">{t("privacy.MSG_34")}</p>
        <ul
          style={{
            listStyleType: "disc",
            marginLeft: "20px",
            marginBottom: "20px",
            textAlign: "justify",
          }}
        >
          <li className="paraMessages" style={{ marginBottom: "10px" }}>
            <span style={{ fontWeight: "bold" }}>{t("privacy.MSG_35")}</span>{" "}
            {t("privacy.MSG_36")}
          </li>
          <li className="paraMessages" style={{ marginBottom: "10px" }}>
            <span style={{ fontWeight: "bold" }}>{t("privacy.MSG_37")}</span>{" "}
            {t("privacy.MSG_38")}
          </li>
          <li className="paraMessages" style={{ marginBottom: "10px" }}>
            <span style={{ fontWeight: "bold" }}>{t("privacy.MSG_39")}</span>{" "}
            {t("privacy.MSG_40")}
          </li>
          <li className="paraMessages">
            <span style={{ fontWeight: "bold" }}>{t("privacy.MSG_41")}</span>{" "}
            {t("privacy.MSG_42")}
          </li>
        </ul>
        <p className="paraMessages">{t("privacy.MSG_43")}</p>
        <div className="paraHeadears" style={{ textDecoration: "none" }}>
          {t("privacy.MSG_44_TITLE")}
        </div>
        <p className="paraMessages">{t("privacy.MSG_45")}</p>
        <p className="paraMessages">{t("privacy.MSG_46")}</p>
        <p className="paraMessages">{t("privacy.MSG_47")}</p>
        <p className="paraMessages">{t("privacy.MSG_48")}</p>
        <div className="paraHeadears" style={{ textDecoration: "none" }}>
          {t("privacy.MSG_49_TITLE")}
        </div>
        <p className="paraMessages">{t("privacy.MSG_50")}</p>
        <p className="paraMessages">{t("privacy.MSG_51")}</p>
        <p className="paraMessages">{t("privacy.MSG_52")}</p>
        <div className="paraHeadears">{t("privacy.MSG_53_TITLE")}</div>
        <p className="paraMessages">{t("privacy.MSG_107")}</p>
        <ul
          style={{
            listStyleType: "disc",
            marginLeft: "20px",
            marginBottom: "20px",
            textAlign: "justify",
          }}
        >
          <li className="paraMessages">{t("privacy.MSG_54")}</li>
          <li className="paraMessages">{t("privacy.MSG_55")}</li>
          <li className="paraMessages">{t("privacy.MSG_56")}</li>
          <li className="paraMessages">{t("privacy.MSG_57")}</li>
          <li className="paraMessages">{t("privacy.MSG_58")}</li>
          <li className="paraMessages">{t("privacy.MSG_59")}</li>
          <li className="paraMessages">{t("privacy.MSG_60")}</li>
          <li className="paraMessages">{t("privacy.MSG_61")}</li>
          <li className="paraMessages">{t("privacy.MSG_62")}</li>
          <li className="paraMessages">{t("privacy.MSG_63")}</li>
          <li className="paraMessages">{t("privacy.MSG_64")}</li>
        </ul>
        <p className="paraMessages">{t("privacy.MSG_65")}</p>
        <p className="paraMessages">{t("privacy.MSG_66")}</p>
        <p className="paraMessages">{t("privacy.MSG_67")}</p>
        <div className="paraHeadears">{t("privacy.MSG_68_TITLE")}</div>
        <div className="paraHeadears" style={{ textDecoration: "none" }}>
          {t("privacy.MSG_69_TITLE")}
        </div>
        <p className="paraMessages">
          {t("privacy.MSG_70")}

          <span style={{ textDecoration: "underline" }}>
            {t("privacy.MSG_102_TITLE")}
          </span>

          {t("privacy.MSG_104")}
        </p>
        <div className="paraHeadears" style={{ textDecoration: "none" }}>
          {t("privacy.MSG_71_TITLE")}
        </div>
        <p className="paraMessages">{t("privacy.MSG_72")}</p>
        <div className="paraHeadears" style={{ textDecoration: "none" }}>
          {t("privacy.MSG_73_TITLE")}
        </div>
        <p className="paraMessages">{t("privacy.MSG_74")}</p>
        <p className="paraMessages">{t("privacy.MSG_75")}</p>
        <div className="paraHeadears" style={{ textDecoration: "none" }}>
          {t("privacy.MSG_76_TITLE")}
        </div>
        <p className="paraMessages">{t("privacy.MSG_77")}</p>
        <div className="paraHeadears" style={{ textDecoration: "none" }}>
          {t("privacy.MSG_78_TITLE")}
        </div>
        <p className="paraMessages">{t("privacy.MSG_79")}</p>
        <p className="paraMessages">{t("privacy.MSG_80")}</p>
        <p className="paraMessages">
          {t("privacy.MSG_81")}

          <span style={{ textDecoration: "underline" }}>
            {t("privacy.MSG_82_TITLE")}
          </span>

          {t("privacy.MSG_105")}
        </p>
        <div className="paraHeadears">{t("privacy.MSG_82_TITLE")}</div>
        <div className="paraHeadears" style={{ textDecoration: "none" }}>
          {t("privacy.MSG_83_TITLE")}
        </div>
        <p className="paraMessages">{t("privacy.MSG_84")}</p>
        <p className="paraMessages">{t("privacy.MSG_85")}</p>
        <p className="paraMessages">{t("privacy.MSG_86")}</p>
        <div className="paraHeadears" style={{ textDecoration: "none" }}>
          {t("privacy.MSG_87_TITLE")}
        </div>
        <p className="paraMessages">{t("privacy.MSG_88")}</p>
        <p className="paraMessages">{t("privacy.MSG_89")}</p>
        <p className="paraMessages">{t("privacy.MSG_90")}</p>
        <div className="paraHeadears">{t("privacy.MSG_91_TITLE")}</div>
        <p className="paraMessages">{t("privacy.MSG_92")}</p>
        <div className="paraHeadears">{t("privacy.MSG_93_TITLE")}</div>
        <p className="paraMessages">{t("privacy.MSG_94")}</p>
        <div className="paraHeadears">{t("privacy.MSG_95_TITLE")}</div>
        <p className="paraMessages">{t("privacy.MSG_96")}</p>
        <p className="paraMessages">
          {t("privacy.MSG_97")}

          <span style={{ textDecoration: "underline" }}>
            {t("privacy.MSG_100_TITLE")}
          </span>

          {t("privacy.MSG_108")}
        </p>
        <p className="paraMessages">{t("privacy.MSG_98")}</p>
        <p className="paraMessages">{t("privacy.MSG_99")}</p>
        <div className="paraHeadears">{t("privacy.MSG_100_TITLE")}</div>
        <p className="paraMessages">{t("privacy.MSG_101")}</p>
        <div className="paraHeadears">{t("privacy.MSG_102_TITLE")}</div>
        <p className="paraMessages">{t("privacy.MSG_103")}</p>

        <br />
      </article>
      <div
        align="center"
        onClick={() => {
          localStorage.setItem("i18nextLng", i18n.language);
        }}
      >
        <a className="linkStyle" onClick={props.clicked}>
          {t("agreement.UNDERSTAND")}
        </a>
      </div>
    </div>
  );
};
class SignUpForm extends Component {
  constructor(props) {
    super(props);
    this.stateChanger = this.stateChanger.bind(this);
    this.passValidator = this.passValidator.bind(this);
    this.captchaOnVerify = this.captchaOnVerify.bind(this);
    this.captcha = React.createRef(null);
    this.state = {
      first_nameValidator: "",
      last_nameValidator: "",
      emailValidator: "",
      passwordValidator: "",
      passwordConfirmValidator: "",
      birthMonthValidator: "",
      birthYearValidator: "",
      genderValidator: "",
      addressValidator: "",
      ethnicityValidator: "",
      showSignUpPassword: false,
      showConfirmSignUpPassword: false,
    };
  }

  componentDidMount() {
    this.props.onRef(this);
    this.yearOptions = getYearOptions();
    this.monthOptions = getMonthOptionsTrans(arrMonthOptions);
    let ethnicityOptions = null;
    // Transform the ethnicities from API to array options
  }
  captchaOnVerify(value) {
    this.props.verifyCaptcha(value);
  }

  resetCaptcha() {
    this.captcha.reset();
  }

  stateChanger(key, value) {
    var data = {};
    data[key] = value;
    this.setState(data);
  }
  emailValidator(e) {
    this.setState({ emailValidator: Validations.email(e.target.value) });
  }
  passValidator(e) {
    if (this.props.signUpForm.password) {
      this.setState({
        passwordValidator: passChecker(e.currentTarget.value),
      });
    }
    // if (
    //   this.props.signUpForm.passwordConfirm &&
    //   e.currentTarget.value !== this.props.signUpForm.passwordConfirm
    // ) {
    //   this.setState({
    //     passwordConfirmValidator: this.props.t(
    //       "reset.PASSWORD_CONFIRM_NOT_MATCH"
    //     ),
    //   });
    // } else {
    //   this.setState({ passwordConfirmValidator: "" });
    // }

    // Re-evaluate mismatch in case Confirm already has text
    const newPwd = this.props.signUpForm.password || "";
    const confirm = this.props.signUpForm.passwordConfirm || "";
    if (confirm.length > 0 && newPwd !== confirm) {
      this.setState({
        passwordConfirmValidator: this.props.t("reset.PASSWORD_CONFIRM_NOT_MATCH"),
      });
    } else {
      this.setState({ passwordConfirmValidator: "" });
    }

    customPassChecker(e.currentTarget.value);
  }
  // checkConfirmPass(e) {
  //   if (
  //     this.props.signUpForm.password &&
  //     e.currentTarget.value !== this.props.signUpForm.password
  //   ) {
  //     this.setState({
  //       passwordConfirmValidator: this.props.t(
  //         "reset.PASSWORD_CONFIRM_NOT_MATCH"
  //       ),
  //       passwordValidator: "",
  //     });
  //   } else {
  //     this.setState({ passwordConfirmValidator: "" });
  //   }
  // }
  checkConfirmPass() {
    const newPwd = this.props.signUpForm.password || "";
    const confirmPwd = this.props.signUpForm.passwordConfirm || "";
    if (confirmPwd.length > 0 && newPwd !== confirmPwd) {
      this.setState({
        passwordConfirmValidator: this.props.t("reset.PASSWORD_CONFIRM_NOT_MATCH"),
        passwordValidator: "",
      });
    } else {
      this.setState({ passwordConfirmValidator: "" });
    }
  }

  render() {
    const captchaFeedbackClass = classNames({
      "invalid-feedback": true,
      notShow: !this.props.showCaptchaInvalid,
    });

    const isSubmitDisable =
      typeof this.props.is_agreeValue === "undefined" ||
      this.props.is_agreeValue === false;
    return (
      <Form
        onSubmit={this.props.handleSubmit}
        className="signup-form"
        style={{ lineBreak: "0px" }}
        ref="Sform"
      >
        <FormGroup row>
          <Col>
            <Field
              component={InputText}
              type="text"
              name="first_name"
              placeholder={this.props.t("signUp.FIRST_NAME")}
              onChange={this.props.onChangeForm}
            />
            {this.state.first_nameValidator && (
              <div className="invalid-feedback">
                {this.state.first_nameValidator}
              </div>
            )}
          </Col>
          <Col>
            <Field
              component={InputText}
              type="text"
              name="last_name"
              placeholder={this.props.t("signUp.LAST_NAME")}
              onChange={this.props.onChangeForm}
            />
            {this.state.last_nameValidator && (
              <div className="invalid-feedback">
                {this.state.last_nameValidator}
              </div>
            )}
          </Col>
        </FormGroup>
        <FormGroup>
          <Field
            component={InputText}
            type="text"
            name="email"
            placeholder={this.props.t("general.EMAIL_OR_PHONE")}
            onChange={(e) => {
              this.props.onChangeForm(e);
              this.emailValidator(e);
            }}
          />
          {this.state.emailValidator && (
            <div className="invalid-feedback">{this.state.emailValidator}</div>
          )}
        </FormGroup>
        <FormGroup row>
          <Col>
            <Field
              component={InputText}
              type={this.state.showSignUpPassword ? "text" : "password"}
              name="password"
              ref="password"
              autocomplete="off"
              placeholder={this.props.t("general.PASSWORD")}
              onChange={(e) => {
                this.props.onChangeForm(e);
                this.passValidator(e);
                this.checkConfirmPass();
              }}
              invalid={
                this.props.signUpForm.password && this.state.passwordValidator
                  ? true
                  : false
              }
              style={{ paddingRight: 36 }}
            />
            <div
              style={{
                position: "absolute",
                top: "5px",
                right: "7px",
                cursor: "pointer",
              }}
              onClick={() =>
                this.setState({
                  showSignUpPassword: !this.state.showSignUpPassword,
                })
              }
            >
              <i
                className={
                  this.state.showSignUpPassword
                    ? "far fa-eye"
                    : "far fa-eye-slash"
                }
                style={{
                  color: "#077bff",
                }}
              />
            </div>
            {this.props.signUpForm.password && (
              <div className="invalid-feedback">
                <span
                  style={{
                    color: "#212529",
                  }}
                >
                  {i18n.t("validations.VALIDATE_PASSWORD")}
                </span>
                <span
                  style={{
                    color:
                      this.props.signUpForm.password && min8Checker
                        ? "#008000"
                        : "#DC3545",
                  }}
                >
                  {i18n.t("validations.VALIDATE_MIN_8")}
                </span>
                <span
                  style={{
                    color:
                      this.props.signUpForm.password && minOneUppercaseChecker
                        ? "#008000"
                        : "#DC3545",
                  }}
                >
                  {i18n.t("validations.VALIDATE_MIN_UPPERCASE")}
                </span>
                <span
                  style={{
                    color:
                      this.props.signUpForm.password && minOneLowercaseChecker
                        ? "#008000"
                        : "#DC3545",
                  }}
                >
                  {i18n.t("validations.VALIDATE_MIN_LOWERCASE")}
                </span>
                <span
                  style={{
                    color:
                      this.props.signUpForm.password && minOneNumberChecker
                        ? "#008000"
                        : "#DC3545",
                  }}
                >
                  {i18n.t("validations.VALIDATE_MIN_NUMBER")}
                </span>
                <span
                  style={{
                    color:
                      this.props.signUpForm.password && minOneSpecialChecker
                        ? "#008000"
                        : "#DC3545",
                  }}
                >
                  {i18n.t("validations.VALIDATE_MIN_SPECIAL_CHARACTER")}
                </span>
              </div>
            )}
          </Col>
          <Col>
            <Field
              component={InputText}
              type={this.state.showConfirmSignUpPassword ? "text" : "password"}
              name="passwordConfirm"
              autocomplete="off"
              onChange={(e) => {
                this.props.onChangeForm(e), 
                this.checkConfirmPass();
              }}
              placeholder={this.props.t("signUp.PASSWORD_CONFIRM")}
              invalid={
                this.props.signUpForm.passwordConfirm &&
                  this.state.passwordConfirmValidator
                  ? true
                  : false
              }
              style={{ paddingRight: 36 }}
            />
            <div
              style={{
                position: "absolute",
                top: "5px",
                right: "7px",
                cursor: "pointer",
              }}
              onClick={() =>
                this.setState({
                  showConfirmSignUpPassword:
                    !this.state.showConfirmSignUpPassword,
                })
              }
            >
              <i
                className={
                  this.state.showConfirmSignUpPassword
                    ? "far fa-eye"
                    : "far fa-eye-slash"
                }
                style={{
                  color: "#077bff",
                }}
              />
            </div>
            {this.state.passwordConfirmValidator && (
              <div className="invalid-feedback">
                {this.state.passwordConfirmValidator}
              </div>
            )}
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col>
            <Field
              name="birthMonth"
              component={Dropdown}
              options={this.monthOptions}
              placeholder={this.props.t("signUp.MONTH")}
              onChange={this.props.onChangeForm}
            />
            {this.state.birthMonthValidator && (
              <div className="invalid-feedback">
                {this.state.birthMonthValidator}
              </div>
            )}
          </Col>
          <Col>
            <Field
              name="birthYear"
              component={Dropdown}
              options={this.yearOptions}
              placeholder={this.props.t("signUp.YEAR")}
              onChange={this.props.onChangeForm}
            />
            {this.state.birthYearValidator && (
              <div className="invalid-feedback">
                {this.state.birthYearValidator}
              </div>
            )}
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col>
            <Field
              name="gender"
              component={Dropdown}
              options={[
                { label: this.props.t("general.MALE_GENDER_TEXT"), value: "1" },
                {
                  label: this.props.t("general.FEMALE_GENDER_TEXT"),
                  value: "2",
                },
                {
                  label: this.props.t("general.OTHER_GENDER_TEXT"),
                  value: "3",
                },
              ]}
              placeholder={this.props.t("signUp.GENDER")}
              onChange={this.props.onChangeForm}
            />
            {this.state.genderValidator && (
              <div className="invalid-feedback">
                {this.state.genderValidator}
              </div>
            )}
          </Col>
          <Col>
            <Field
              name="lang"
              component={Dropdown}
              options={USER_LANG}
              className="lang"
              placeholder={this.props.t("profile.LANGUAGE")}
              onChange={this.props.onChangeForm}
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col>
            <Field
              component={InputAmount}
              name="weight"
              placeholder={this.props.t("profile.WEIGHT")}
              onKeyUp={(e) => this.props.onChangeForm(e)}
              amounNewValue={this.props.signUpForm.weight}
              pattern="[0-9.]*"
            />
            <span
              style={{
                position: "absolute",
                top: "5px",
                right: "13px",
                color: "#999",
              }}
            >
              {this.props.t("profile.WEIGHT_UNIT_TABLE")}
            </span>
          </Col>
          <Col>
            <Field
              component={InputAmount}
              name="height"
              placeholder={this.props.t("profile.HEIGHT")}
              onKeyUp={(e) => this.props.onChangeForm(e)}
              amounNewValue={this.props.signUpForm.height}
              pattern="[0-9.]*"
            />
            <span
              style={{
                position: "absolute",
                top: "5px",
                right: "13px",
                color: "#999",
              }}
            >
              {this.props.t("profile.HEIGHT_UNIT_TABLE")}
            </span>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col>
            <Field
              name="group"
              component={Dropdown}
              options={this.props.t("USER_GROUP", {
                returnObjects: true,
              })}
              className="group"
              placeholder={this.props.t("profile.GROUP")}
              onChange={this.props.onChangeForm}
            />
          </Col>
          <Col>
            <div
              className="signUpText"
              style={{
                position: "absolute",
              }}
            >
              <p>{this.props.t("signUp.ADDITIONAL_INFO_TEXT")}</p>
            </div>
          </Col>
        </FormGroup>
        <FormGroup style={{ display: "flex" }}>
          <div className="recaptcha">
            <center>
              <ReCAPTCHA
                ref={(e) => (this.captcha = e)}
                sitekey={config.recaptchaSiteKey}
                onChange={this.captchaOnVerify}
              />
            </center>
          </div>
        </FormGroup>
        <FormGroup>
          <div className="agreement-checkbox">
            <Field
              component={CheckBox}
              name="is_agree"
              onChange={this.props.onChangeForm}
            />
          </div>
          <div className="agreement-link">
            {this.props.t("signUp.AGREEMENT_LABEL")}
            <a
              className="linkStyle"
              onClick={(e) => this.props.clicked(e, "agreement")}
            >
              {this.props.t("signUp.AGREEMENT_LINK")}
            </a>
            <span>{this.props.t("signUp.AND_TEXT")}</span>
            <a
              className="linkStyle"
              onClick={(e) => this.props.clicked(e, "privacy")}
            >
              {this.props.t("signUp.AGREEMENT_LINK_2")}
            </a>
          </div>
        </FormGroup>
        <div className="submit2">
          <Button
            className="button-submit"
            disabled={
              this.props.isCaptchaValid ? this.props.disabled.submit : true
            }
            color="primary"
          >
            {this.props.t("general.SUBMIT")}
          </Button>
        </div>
        <p
          onClick={() => {
            localStorage.setItem("i18nextLng", i18n.language);
          }}
        >
          {this.props.t("signUp.ALREADY_HAVE_ACCOUNT")}
          <a href="/" style={{ color: "#007bff" }}>
            {this.props.t("signUp.LOGIN_HERE")}
          </a>
        </p>
      </Form>
    );
  }
}

SignUpForm = reduxForm({
  form: "formSignUp",
  enableReinitialize: true,
})(SignUpForm);

// Decorate with connect to read form values
const selector = formValueSelector("formSignUp");
SignUpForm = connect((state) => ({
  initialValues: state.signUp.formInitial,
  // can select values individually
  is_agreeValue: selector(state, "is_agree"),
}))(SignUpForm);

class SignUp extends Component {
  constructor(props) {
    super(props);
    this.signupFormRef = React.createRef();
    this.state = {
      showCaptchaInvalid: false,
      isCaptchaValid: false,
      showAgreement: "",
      submitFlag: false,
    };
    this.handleToggle = this.handleToggle.bind(this);
    this.resetForm = this.resetForm.bind(this);
    window.signup = {};
  }
  componentDidMount() {
    const values = queryString.parse(this.props.location.search);
    let formInitial = null;
    var _encKey = config.encryptionKey;
    // form
    if (typeof values.formInitial !== "undefined") {
      if (_encKey !== undefined) {
        var _strToDec = window.decodeURIComponent(values.formInitial);
        var _bytes = CryptoJS.AES.decrypt(_strToDec, _encKey);
        var _decStr = _bytes.toString(CryptoJS.enc.Utf8);
        try {
          formInitial = JSON.parse(_decStr);
        } catch (err) {
          formInitial = null;
        }
      } else {
        formInitial = JSON.parse(window.decodeURIComponent(values.formInitial));
      }
    }

    // the redirectUrl
    if (typeof values.redirectUrl !== "undefined" && formInitial !== null) {
      var _strToDec = window.decodeURIComponent(values.redirectUrl);
      var _bytes = CryptoJS.AES.decrypt(_strToDec, _encKey);
      this.redirectUrl = _bytes.toString(CryptoJS.enc.Utf8);
    } else if (
      typeof values.redirectUrl !== "undefined" &&
      formInitial !== null
    ) {
      setTimeout(() => {
        window.location = config.signupRedirectErrorUrl;
      }, 0);
    }

    this.props.formInitialization(formInitial);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.status === statusEnum.SUCCESS) {
      if (typeof this.redirectUrl !== "undefined") {
        // The redirect URL received from the server already have payload passed
        // so we append a new payload value for the verification of the user
        var _strToEnc = nextProps.response._id + "|" + nextProps.response.email;
        var _encStr = CryptoJS.AES.encrypt(
          _strToEnc,
          config.encryptionKey
        );
        var _newRedirectUrl =
          this.redirectUrl +
          "&" +
          config.serverUserSignupPayload2Name +
          "=" +
          window.encodeURIComponent(_encStr);
      } else {
        //setTimeout(() => this.props.history.push('/'), 2000);
      }
    }
  }

  componentWillUnmount() {
    this.props.setDefaultState();
  }

  handleSubmit(values) {
    values = this.props.signUpForm;
    //validation
    var validationFlag = true;
    var {
      first_name,
      last_name,
      email,
      password,
      passwordConfirm,
      birthMonth,
      birthYear,
      gender,
    } = values;
    let address = window.signup.address;
    let ethnicity = window.signup.ethnicity;

    if (email == undefined || email == null || email == "") {
      this.signupFormRef.stateChanger("emailValidator", "required");
      validationFlag = false;
    } else {
      var emailvalidation = Validations.email(email);
      if (emailvalidation) {
        this.signupFormRef.stateChanger("emailValidator", emailvalidation);
        validationFlag = false;
      } else {
        this.signupFormRef.stateChanger("emailValidator", "");
      }
    }
    if (password == undefined || password == null || password == "") {
      this.signupFormRef.stateChanger("passwordValidator", "required");
      validationFlag = false;
    } else {
      var passFinally = passChecker(password);
      if (passFinally) {
        this.signupFormRef.stateChanger("passwordValidator", passFinally);
        validationFlag = false;
      } else {
        this.signupFormRef.stateChanger("passwordValidator", "");
      }
    }
    if (
      passwordConfirm == undefined ||
      passwordConfirm == null ||
      passwordConfirm == ""
    ) {
      this.signupFormRef.stateChanger("passwordConfirmValidator", "required");
      validationFlag = false;
    } else {
      if (password !== passwordConfirm) {
        this.signupFormRef.stateChanger(
          "passwordConfirmValidator",
          this.props.t("reset.PASSWORD_CONFIRM_NOT_MATCH")
        );
        validationFlag = false;
      } else {
        this.signupFormRef.stateChanger("passwordConfirmValidator", "");
      }
    }
    if (!validationFlag) return;
    const user = values;
    user.ethnicity = window.signup.ethnicity;
    user.birthday = {
      month: values.birthMonth,
      year: values.birthYear,
    };
    user.group = "1100";
    user.tzm = moment().utcOffset();

    this.props.signUpSubmit(user);
    this.signupFormRef.resetCaptcha();
  }

  setCaptchaStatus(isValid) {
    this.setState({ showCaptchaInvalid: !isValid });
    this.setState({ isCaptchaValid: isValid });
  }

  cancelClicked() {
    this.props.history.push("/");
  }

  handleToggle(e, type) {
    if (!type) {
      this.setState({ showAgreement: "" });
    } else if (type === "agreement") {
      this.setState({
        showAgreement: (
          <AgreementModal t={this.props.t} clicked={this.handleToggle} />
        ),
      });
    } else if (type === "privacy") {
      this.setState({
        showAgreement: (
          <PrivacyModal t={this.props.t} clicked={this.handleToggle} />
        ),
      });
    }
  }
  resetForm() {
    this.signupFormRef.resetCaptcha();
    this.props.onResetForm();
  }

  render() {
    const { isLoading, status, actionResponse, t, ethnicities, locations } =
      this.props;
    var _pageFitter = "vPage flex";

    return (
      <div className={`${_pageFitter} auth-modern signup-modern`}>
        <div className="">
          {this.state.showAgreement}
          <Loading isLoading={isLoading} />
          <Valert
            display={false}
            title={t("profile.SAVE_CONFIRMATION_TITLE")}
            question={t("profile.SAVE_CONFIRMATION_TEXT")}
            onRef={(ref) => (this.saveValert = ref)}
            positiveAction={this.handleSubmit.bind(this)}
            positiveText={t("general.OK_PROMPT_TEXT")}
            negativeText={t("general.CANCEL")}
          />
          <Valert
            display={this.props.submit}
            title={t("signUp.REGISTERING_EMAIL_TITLE")}
            question={t("signUp.REGISTER_SUCCESS")}
            positiveAction={() => window.location.reload()}
            positiveText={t("general.OK_PROMPT_TEXT")}
            readOnly={true}
          />
          <Valert
            display={this.props.submitFailed}
            title={t("profile.REGISTERED_EMAIL_ADDRESS_TITLE")}
            question={t("profile.REGISTERED_EMAIL_ADDRESS_TEXT", {
              email: this.props.signUpForm.email,
            })}
            positiveAction={() => {
              this.setState({
                showCaptchaInvalid: false,
                isCaptchaValid: false,
              });
            }}
            positiveText={t("general.OK_PROMPT_TEXT")}
            readOnly={true}
          />
          <div className="justify-content-center">
            <div>
              <SignUpForm
                onRef={(ref) => (this.signupFormRef = ref)}
                onSubmit={() => this.saveValert.changeStatus()}
                onCancel={this.cancelClicked.bind(this)}
                clicked={this.handleToggle.bind(this)}
                verifyCaptcha={this.setCaptchaStatus.bind(this)}
                showCaptchaInvalid={this.state.showCaptchaInvalid}
                t={t}
                ethnicities={ethnicities}
                locations={locations}
                submitFlag={this.state.submitFlag}
                disabled={this.props.disabled}
                onChangeForm={this.props.onChangeForm}
                signUpForm={this.props.signUpForm}
                amountReseter={this.props.amountReseter}
                isCaptchaValid={this.state.isCaptchaValid}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SignUp = translate("translations")(SignUp);

const mapStateToProps = (state) => ({ ...state.signUp });

const matchDispatchToProps = (dispatch) =>
  bindActionCreators({ ...signUpActions }, dispatch);

export default connect(mapStateToProps, matchDispatchToProps)(SignUp);



// WEBPACK FOOTER //
// ./src/pages/SignUp.js